/**
 * Seletor de visualização do grid de produtos no mobile (1 ou 2 colunas).
 *
 * Aplica a classe `product-grid-view--1` ou `product-grid-view--2` no
 * #ProductGridContainer (elemento estável: apenas seu innerHTML é trocado
 * quando os filtros recarregam via AJAX, então a classe persiste).
 * A preferência é salva no localStorage para manter a escolha entre páginas.
 */
class ProductGridView extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'product-grid-view';
    this.defaultView = this.dataset.default || '2';
    this.buttons = this.querySelectorAll('.product-grid-view__button');
    this.container = document.getElementById('ProductGridContainer');

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.setView(button.dataset.view));
    });

    this.setView(this.getStoredView(), false);
  }

  getStoredView() {
    try {
      return localStorage.getItem(this.storageKey) || this.defaultView;
    } catch (error) {
      return this.defaultView;
    }
  }

  setView(view, persist = true) {
    if (!this.container) return;

    this.container.classList.remove('product-grid-view--1', 'product-grid-view--2');
    this.container.classList.add(`product-grid-view--${view}`);

    this.buttons.forEach((button) => {
      const isActive = button.dataset.view === view;
      button.classList.toggle('product-grid-view__button--active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (persist) {
      try {
        localStorage.setItem(this.storageKey, view);
      } catch (error) {
        // localStorage indisponível (ex: modo privado) — ignora.
      }
    }
  }
}

if (!customElements.get('product-grid-view')) {
  customElements.define('product-grid-view', ProductGridView);
}
